// Source: https://github.com/imandra-ai/code-logic-bench/tree/hy/add-opus-4-6/analysis
// Computed from aggregated_metrics.csv (model_metric_pivot) and aggregated_metrics_full.csv
// Regenerate via: python3 scripts/gen-chart-data.py (if available)

// ── Model Comparison (Radar + Grouped Bar) ───────────────────────────────────
// Per-model per-metric averages from model_metric_pivot.csv
// Ordered to match chart display order (metric axis)
export const modelComparisonData = [
  {
    metric: 'State Space Estimation',
    'anthropic/ claude-opus-4.6': 0.2482,
    'anthropic/ claude-opus-4.5': 0.2406,
    'anthropic/ claude-sonnet-4.5': 0.2317,
    'google/gemini-3-pro': 0.2114,
    'openai/ gpt-5.2': 0.2107,
    'x-ai/ grok-code-fast-1': 0.1902,
    'LLM + CodeLogician': 1.0,
  },
  {
    metric: 'Control Flow Understanding',
    'anthropic/ claude-opus-4.6': 0.7994,
    'anthropic/ claude-opus-4.5': 0.7873,
    'anthropic/ claude-sonnet-4.5': 0.7318,
    'google/gemini-3-pro': 0.6944,
    'openai/ gpt-5.2': 0.8105,
    'x-ai/ grok-code-fast-1': 0.7073,
    'LLM + CodeLogician': 1.0,
  },
  {
    metric: 'Edge Case Detection',
    'anthropic/ claude-opus-4.6': 0.7453,
    'anthropic/ claude-opus-4.5': 0.6397,
    'anthropic/ claude-sonnet-4.5': 0.6272,
    'google/gemini-3-pro': 0.5512,
    'openai/ gpt-5.2': 0.6129,
    'x-ai/ grok-code-fast-1': 0.5528,
    'LLM + CodeLogician': 1.0,
  },
  {
    metric: 'Decision Boundary',
    'anthropic/ claude-opus-4.6': 0.8145,
    'anthropic/ claude-opus-4.5': 0.7626,
    'anthropic/ claude-sonnet-4.5': 0.7359,
    'google/gemini-3-pro': 0.6592,
    'openai/ gpt-5.2': 0.6866,
    'x-ai/ grok-code-fast-1': 0.6299,
    'LLM + CodeLogician': 1.0,
  },
  {
    metric: 'Outcome Precision',
    'anthropic/ claude-opus-4.6': 0.5873,
    'anthropic/ claude-opus-4.5': 0.6107,
    'anthropic/ claude-sonnet-4.5': 0.6236,
    'google/gemini-3-pro': 0.5785,
    'openai/ gpt-5.2': 0.6587,
    'x-ai/ grok-code-fast-1': 0.5931,
    'LLM + CodeLogician': 1.0,
  },
  {
    metric: 'Direction Accuracy',
    'anthropic/ claude-opus-4.6': 0.7772,
    'anthropic/ claude-opus-4.5': 0.754,
    'anthropic/ claude-sonnet-4.5': 0.7043,
    'google/gemini-3-pro': 0.7033,
    'openai/ gpt-5.2': 0.8058,
    'x-ai/ grok-code-fast-1': 0.7894,
    'LLM + CodeLogician': 1.0,
  },
  {
    metric: 'Coverage Completeness',
    'anthropic/ claude-opus-4.6': 0.573,
    'anthropic/ claude-opus-4.5': 0.5237,
    'anthropic/ claude-sonnet-4.5': 0.5063,
    'google/gemini-3-pro': 0.4489,
    'openai/ gpt-5.2': 0.5071,
    'x-ai/ grok-code-fast-1': 0.4627,
    'LLM + CodeLogician': 1.0,
  },
]

// ── Metric Averages ──────────────────────────────────────────────────────────
// Mean across all 6 models per metric (from model_metric_pivot.csv)
export interface MetricAverage {
  metric: string
  score: number
  withCodeLogician: number
}

export const metricAveragesData: MetricAverage[] = [
  { metric: 'State Space Estimation', score: 0.2221, withCodeLogician: 1.0 },
  {
    metric: 'Control Flow Understanding',
    score: 0.7551,
    withCodeLogician: 1.0,
  },
  { metric: 'Edge Case Detection', score: 0.6215, withCodeLogician: 1.0 },
  { metric: 'Decision Boundary Clarity', score: 0.7148, withCodeLogician: 1.0 },
  { metric: 'Outcome Precision', score: 0.6087, withCodeLogician: 1.0 },
  { metric: 'Direction Accuracy', score: 0.7557, withCodeLogician: 1.0 },
  { metric: 'Coverage Completeness', score: 0.5036, withCodeLogician: 1.0 },
]

// ── Median Scores ────────────────────────────────────────────────────────────
// Median across all individual scores (all models, eval_models, projects, questions)
// Computed from aggregated_metrics_full.csv
export interface MetricMedian {
  metric: string
  medianScore: number
  withCodeLogician: number
}

export const metricMediansData: MetricMedian[] = [
  {
    metric: 'State Space Estimation',
    medianScore: 0.112,
    withCodeLogician: 1.0,
  },
  {
    metric: 'Control Flow Understanding',
    medianScore: 0.875,
    withCodeLogician: 1.0,
  },
  { metric: 'Edge Case Detection', medianScore: 0.75, withCodeLogician: 1.0 },
  {
    metric: 'Decision Boundary Clarity',
    medianScore: 0.9091,
    withCodeLogician: 1.0,
  },
  { metric: 'Outcome Precision', medianScore: 0.75, withCodeLogician: 1.0 },
  { metric: 'Direction Accuracy', medianScore: 1.0, withCodeLogician: 1.0 },
  { metric: 'Coverage Completeness', medianScore: 0.5, withCodeLogician: 1.0 },
]

// ── Model Averages ───────────────────────────────────────────────────────────
// Mean across all 7 metrics per model (from model_metric_pivot.csv), sorted best-first
export interface ModelAverage {
  model: string
  averageScore: number
  withCodeLogician: number
  displayName: string
}

export const modelAveragesData: ModelAverage[] = [
  {
    model: 'anthropic/claude-opus-4.6',
    averageScore: 0.6493,
    withCodeLogician: 1.0,
    displayName: 'anthropic/ claude-opus-4.6',
  },
  {
    model: 'anthropic/claude-opus-4.5',
    averageScore: 0.6169,
    withCodeLogician: 1.0,
    displayName: 'anthropic/ claude-opus-4.5',
  },
  {
    model: 'openai/gpt-5.2',
    averageScore: 0.6132,
    withCodeLogician: 1.0,
    displayName: 'openai/ gpt-5.2',
  },
  {
    model: 'anthropic/claude-sonnet-4.5',
    averageScore: 0.5944,
    withCodeLogician: 1.0,
    displayName: 'anthropic/ claude-sonnet-4.5',
  },
  {
    model: 'x-ai/grok-code-fast-1',
    averageScore: 0.5608,
    withCodeLogician: 1.0,
    displayName: 'x-ai/ grok-code-fast-1',
  },
  {
    model: 'google/gemini-3-pro',
    averageScore: 0.5496,
    withCodeLogician: 1.0,
    displayName: 'google/gemini-3-pro',
  },
]

// ── Score Distribution (Box Plot) ────────────────────────────────────────────
// Statistics computed from aggregated_metrics_full.csv (all individual scores)
// Whiskers: 1.5×IQR rule. min/max are whisker ends (not data extremes).
// Outliers beyond whiskers are listed separately (clamped to [0,1] in display).
export interface BoxPlotData {
  metric: string
  min: number
  q1: number
  median: number
  q3: number
  max: number
  outliers?: number[]
}

export const boxPlotData: BoxPlotData[] = [
  {
    metric: 'State Space Estimation',
    min: 0.0,
    q1: 0.0,
    median: 0.112,
    q3: 0.1966,
    max: 0.3869,
    // Outliers beyond q3 + 1.5×IQR (≈ 0.493): scores of 0.5 and 1.0
    outliers: [0.5, 1.0],
  },
  {
    metric: 'Control Flow Understanding',
    min: 0.125,
    q1: 0.625,
    median: 0.875,
    q3: 1.0,
    max: 1.0,
    // One outlier at 0.0 (below q1 - 1.5×IQR = 0.0625)
    outliers: [0.0],
  },
  {
    metric: 'Edge Case Detection',
    min: 0.0,
    q1: 0.25,
    median: 0.75,
    q3: 1.0,
    max: 1.0,
    // One anomalous score of -3.0 in the raw data (clamped to 0 in display)
    outliers: [-3.0],
  },
  {
    metric: 'Decision Boundary',
    min: 0.0,
    q1: 0.5,
    median: 0.9091,
    q3: 1.0,
    max: 1.0,
    outliers: [],
  },
  {
    metric: 'Outcome Precision',
    min: 0.0,
    q1: 0.2,
    median: 0.75,
    q3: 1.0,
    max: 1.0,
    outliers: [],
  },
  {
    metric: 'Direction Accuracy',
    min: 0.0,
    q1: 0.5,
    median: 1.0,
    q3: 1.0,
    max: 1.0,
    outliers: [],
  },
  {
    metric: 'Coverage Completeness',
    min: 0.0,
    q1: 0.14,
    median: 0.5,
    q3: 1.0,
    max: 1.0,
    outliers: [],
  },
]
